import React, { FC } from "react";


export const Script:
    FC<
        React.DetailedHTMLProps<
            React.ScriptHTMLAttributes<HTMLScriptElement>,
            HTMLScriptElement
        > & { content?: string; }
    > =
    ({ content, children, ...props }) =>
    {
        return React.createElement("script", { dangerouslySetInnerHTML: { __html: content ?? children }, ...props });
    };
